export type ComplianceWindow = 2 | 4;

export const STOCK_AREA_COMPLIANCE_WINDOWS: readonly ComplianceWindow[] = [2, 4];
export const DEFAULT_COMPLIANCE_WINDOW: ComplianceWindow = 2;

export type StockAreaApiRecord = Record<string, unknown> & {
  site: string;
  stockArea: string;
  assayTrackable: boolean;
  complianceTimeWindow: number | string;
  updatedAt: string;
  updatedBy: string;
};

export interface StockAreaApiResponse {
  stockAreaData: StockAreaApiRecord[];
}

export interface StockAreaFilter {
  site?: string;
  area?: string;
  stockArea?: string;
  CDA?: string;
  deviceType?: string;
  stockAreaType?: string;
  assayTrackable?: boolean;
}

export type StockAreaRecord = Record<string, unknown> & {
  site?: string;
  stockArea?: string;
  assayTrackable: boolean;
  complianceTimeWindow: ComplianceWindow;
  updatedAt?: string;
  updatedBy?: string;
};

export type StockAreaConfigUpdateRow = Record<string, unknown> & {
  assayTrackable?: boolean;
  complianceTimeWindow?: ComplianceWindow;
};